// Application shell: authentication gate, routing. This frontend is
// admin-only — everything else (projects, credits, keys) is the API.

import { Routes, Route } from 'react-router-dom';
import { useAuth } from './auth';
import { Loading } from './components/ui';
import { Logo } from './components/Logo';
import { ThemeToggle } from './components/ThemeToggle';
import LoginPage from './pages/Login';
import AdminPage from './pages/Admin';

export default function App() {
  const { profile, loading, logout } = useAuth();

  if (loading) {
    return (
      <div className="auth-screen">
        <Loading label="Starting Cloudish…" />
      </div>
    );
  }

  if (!profile) return <LoginPage />;

  return (
    <div className="shell">
      <div className="main">
        <div className="mobile-topbar" style={{ justifyContent: 'space-between' }}>
          <Logo height={18} />
          <div className="row row-tight">
            <ThemeToggle />
            <button type="button" className="btn btn-sm" onClick={logout}>
              Sign out
            </button>
          </div>
        </div>
        <Routes>
          <Route path="/*" element={<AdminPage />} />
        </Routes>
      </div>
    </div>
  );
}
